<div class="modal modal--single-alert">
  <app-single-alert
    [isModal]="true"
    heading="Are you sure you want to cancel your changes?">
    <ng-container copy>
      If you go ahead and cancel, you'll lose the changes you've just made.
      <br>To keep your changes, please check and save the details we've already filled in for you.
    </ng-container>
    <ng-container buttons>
      <button id="modal-cancel" theme="primary" cancelFocus dlg-button (click)="onSave()">Check and save changes</button>
      <button id="modal-delete" cancelFocus dlg-button (click)="onCancel()">Cancel all my changes</button>
    </ng-container>
  </app-single-alert>
</div>
